<template>
  <section
    class="section-b-space d-block contact-section"
    v-if="contactPage"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="something">
            <h4>{{ _T_DB(contactPage,'content_heading') }}</h4>
            <div v-html="_T_DB(contactPage,'content')"></div>
            <img class="img-fluid" :src="contactPage.content_image" alt="" />
            <form class="default-form row" v-if="false">
              <div class="col-md-6 form-group">
                <label>{{ _T('Your name') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="name"
                  :class="{ 'border-danger': errors.name }"
                />
                <span class="validation-error  d-block pt-1" v-if="errors.name">
                  {{ errors.name }}
                </span>
              </div>
              <div class="col-md-6 form-group">
                <label>{{ _T('Email address') }}</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="email"
                  :class="{ 'border-danger': errors.email }"
                />
                <span
                  class="validation-error  d-block pt-1"
                  v-if="errors.email"
                >
                  {{ errors.email }}
                </span>
              </div>
              <div class="col-md-12 form-group">
                <label>{{ _T('Subject') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subject"
                  :class="{ 'border-danger': errors.subject }"
                />
                <span
                  class="validation-error  d-block pt-1"
                  v-if="errors.subject"
                >
                  {{ errors.subject }}
                </span>
              </div>
              <div class="col-md-12 form-group mb-0">
                <label class="d-block">{{ _T('Messages') }}</label>
                <textarea
                  class="form-control"
                  rows="6"
                  v-model="message"
                  :class="{ 'border-danger': errors.message }"
                ></textarea>

                <span
                  class="validation-error  d-block pt-1"
                  v-if="errors.message"
                >
                  {{ errors.message }}
                </span>
              </div>
              <div class="col-12">
                <progress-bar class="btn-lg" v-if="processInProgress(process)">
                  {{ _T('Submitting') }}
                </progress-bar>
                <button
                  v-else
                  type="button"
                  class="btn btn-solid btn-lg"
                  @click="validateForm()"
                >
                  {{ _T('Submit') }}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="col-lg-5 offset-lg-1" v-if="currentBrand">
          <div class="contact-details">
            <ul>
              <li>
                <h6>
                  <svg width="24" height="24" fill="none" class="mr-2">
                    <use xlink:href="#contact-pin-g" />
                  </svg>
                  <span>{{ _T('Address') }}</span>
                </h6>
                <h5 v-if="domainBasedBrand">
                  {{ _T_DB(currentBrand, 'address') }}
                </h5>
                <h5 v-else>{{ _T_DB(all_goorder_settings[0], 'address') }}</h5>
              </li>
              <li>
                <h6>
                  <svg width="24" height="24" fill="none" class="mr-2">
                    <use xlink:href="#contact-mail-g" />
                  </svg>
                  <span>{{ _T('Email') }}</span>
                </h6>
                <h5 v-if="domainBasedBrand">{{ currentBrand.email }}</h5>
                <h5 v-else>{{ all_goorder_settings[0].email }}</h5>
              </li>
              <li>
                <h6>
                  <svg width="24" height="24" fill="none" class="mr-2">
                    <use xlink:href="#contact-phone-g" />
                  </svg>
                  <span>{{ _T('Phone Number') }}</span>
                </h6>
                <h5 v-if="domainBasedBrand">
                  {{ currentBrand.contact_phone }}
                </h5>
                <h5 v-else>{{ all_goorder_settings[0].contact_phone }}</h5>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

import ProgressBar from '@/components/Elements/ProgressBar'

import { validateEmail, handleApiErrors } from '@/utils/main_utils'
export default {
  name: 'StaticContactUs',
  data() {
    return {
      name: '',
      email: '',
      subject: '',
      message: '',
      brand_id: '',
      errors: '',
      process: 'contact-us-form',
    }
  },
  components: {
    ProgressBar,
  },
  computed: {
    ...mapGetters([
      'find_brand_by_main_id',
      'currentBrandId',
      'domainBasedBrand',
      '_T',
      '_T_DB',
      'all_static_pages',
      'all_goorder_settings',
      'web_user',
      'processInProgress',
    ]),
    currentBrand() {
      if (this.domainBasedBrand && this.currentBrandId) {
        return this.find_brand_by_main_id(this.currentBrandId)
      }
      return []
    },
    contactPage() {
      if (this.all_static_pages) {
        return this.all_static_pages.find(page => page.type === 'contact')
      }
      return {}
    },
  },
  methods: {
    validateForm() {
      this.errors = {}
      this.errors.count = 0
      if (!this.name.trim()) {
        this.errors.name = this._T('Name is required')
        this.errors.count = 1
      }
      if (!this.email.trim()) {
        this.errors.email = this._T('Email is required')
        this.errors.count = 1
      }
      if (!validateEmail(this.email)) {
        this.errors.email = this._T('Please provide a valid email')
        this.errors.count = 1
      }
      if (!this.subject.trim()) {
        this.errors.subject = this._T('Subject is required')
        this.errors.count = 1
      }
      if (!this.message.trim()) {
        this.errors.message = this._T('Message is required')
        this.errors.count = 1
      }
      if (this.errors.count === 0) {
        this.sendMessage()
      }
    },
    sendMessage() {
      if (!this.processInProgress(this.process)) {
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        this.$store
          .dispatch('contact_us', {
            name: this.name,
            email: this.email,
            subject: this.subject,
            message: this.message,
            brand_id: this.currentBrandId || null,
          })
          .then(resp => {
            let responseData = resp.data
            if (responseData.status === 'form_errors') {
              let errors = handleApiErrors(responseData.form_errors)
              this.$store.dispatch('showNotification', {
                text: this._T(errors),
                status: 'error',
              })
            } else {
              let message = responseData.message || this._T('Record updated succesfully')
              this.$store.dispatch('showNotification', {
                text: this._T(message),
                status: 'success',
              })
              this.resetForm()
            }
          })
          .catch(() => {
            this.$store.dispatch('showNotification', {
              text: this._T('Your request was not successfull'),
              status: 'error',
            })
          })
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
    resetForm() {
      this.subject = ''
      this.message = ''
      this.name = ''
      this.email = ''
    },
  },
  mounted() {
    this.email = this.web_user ? this.web_user.email : ''
    this.name = this.web_user ? this.web_user.name : ''
  },
}
</script>

<style lang="scss" scoped>
.something {
  h4 {
    font-weight: 500;
    color: $light-font;
    margin-bottom: $px14;
  }
  h2 {
    line-height: calc(#{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
    letter-spacing: 0.02em;
    color: $font-color;
    text-transform: inherit;
  }
  img {
    margin-top: $px6;
  }
  .default-form {
    margin-top: calc(#{$px25} + (58 - 25) * ((100vw - #{$px320}) / (1920 - 320)));
    .form-group {
      label {
        font-size: $px14;
        color: #8e94a0;
      }
    }
    .btn {
      margin-top: calc(#{$px20} + (38 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
    }
  }
}
.contact-details {
  h6 {
    font-size: $px12;
    line-height: $px15;
    margin-bottom: $px12;
    span {
      vertical-align: middle;
    }
  }
  h5 {
    font-weight: 600;
  }
  ul {
    li {
      display: block;
      margin-bottom: calc(#{$px20} + (85 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
    }
  }
}
.social-icons {
  li {
    a {
      i {
        color: #d3d3d3;
        font-size: calc(#{$px25} + (40 - 25) * ((100vw - #{$px320}) / (1920 - 320)));
        transition: 0.5s;
      }
      &:hover {
        i {
          color: $color-tertiary;
          transition: 0.5s;
        }
      }
    }
    + li {
      margin-left: calc(#{$px10} + (45 - 10) * ((100vw - #{$px320}) / (1920 - 320)));
    }
  }
}
.contact-info {
  background-image: url('/images/contact/bg-book.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
  width: 100%;
  text-align: center;
  padding: calc(#{$px60} + (136 - 60) * ((100vw - #{$px320}) / (1920 - 320))) 0;
  position: relative;
  z-index: 1;
  &::after {
    background-color: $color-tertiary;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    z-index: -1;
  }
  h3 {
    font-size: calc(#{$px20} + (30 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
    line-height: calc(#{$px31} + (36 - 31) * ((100vw - #{$px320}) / (1920 - 320)));
    letter-spacing: -0.8px;
    color: $white;
    text-transform: inherit;
    font-weight: normal;
    margin: -6px 0 calc(#{$px30} + (38 - 30) * ((100vw - #{$px320}) / (1920 - 320)));
  }
  .btn {
    &:hover,
    &:focus,
    &:active {
      color: $black;
    }
  }
}
@media (max-width: 991px) {
  .contact-details {
    padding-top: $px40;
  }
}
</style>
